import { render } from "./IconEdit1.vue?vue&type=template&id=061bcac0&ts=true"
import script from "./IconEdit1.vue?vue&type=script&lang=ts"
export * from "./IconEdit1.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__